'use client';

import {
  ApiManagedUserScoreProfileSession,
  ApiMostRecentSessionSummary,
  ApiScoreCard,
  ApiScoreCardv2,
  ApiUserScoreCardSummary,
  ISimulationScore,
} from '@/types';

type FallbackScore = {
  score_max?: number;
  score?: number;
  scoreMax?: number;
  total_score?: number;
  totalScore?: number;
};

type AnyScore =
  | ApiManagedUserScoreProfileSession
  | ApiMostRecentSessionSummary
  | ApiScoreCard
  | ApiScoreCardv2
  | ApiUserScoreCardSummary
  | ISimulationScore
  | FallbackScore
  | any;

// ================================
// Public Domain Policy
// ================================

/**
 * Calculates the score percentage for a score.
 * Prioritizes explicit `score_percentage` field from API, falls back to calculated
 * percentage, or returns null if sufficient data is unavailable.
 *
 * @param score - The API score object
 * @returns The score percentage as a number, or null if unavailable
 */
export function getScorePercentage(score?: AnyScore): number | null {
  if (!score) {
    return null;
  }

  if ('score_percentage' in score && score?.score_percentage !== undefined) {
    // API
    return score.score_percentage as number;
  }

  if ('scorePercentage' in score && score?.scorePercentage !== undefined) {
    // frontend
    return score.scorePercentage as number;
  }

  if (score?.score_max && score?.total_score) {
    // API
    return score.total_score / score.score_max;
  }

  if (score?.score_max && score?.score) {
    // API
    return score.score / score.score_max;
  }

  if (score?.scoreMax && score?.totalScore) {
    // frontend
    return score.totalScore / score.scoreMax;
  }

  if (score?.scoreMax && score?.score) {
    // frontend
    return score.score / score.scoreMax;
  }

  return null;
}
